import flatten from 'lodash/flatten';
import { IReducedProvider } from 'src/pages/ConnectedProviders/ConnectedProvidersPayment/ConnectedProvidersPayment.types';
import { RootState } from 'src/store';
import { createSelector } from '@reduxjs/toolkit';

import { IProviderListData } from './types';

export const selectProvidersLoading = (state: RootState): boolean => state.providersPayment.isLoading;
export const selectProvidersLoaded = (state: RootState): boolean => state.providersPayment.isLoaded;
export const selectProvidersData = (state: RootState): IProviderListData => state.providersPayment.data;
export const selectProvidersMerchantsData = (state: RootState): IProviderListData => state.providersPayment.merchantAccounts;
export const totalElements = (state: RootState) => state.providersPayment.merchantAccounts.totalElements;

export const getSortedProvidersData = createSelector(selectProvidersMerchantsData, (entity) => {
  if (!entity) {
    return;
  }

  return entity.content?.reduce<IReducedProvider[]>((result, provider) => {
    const tempRes = flatten(
      provider.integrations?.map((integration) =>
        integration.merchantAccounts.map((account) => ({
          rowspan: { count: 0, name: 'providerName' },
          providerName: provider.name,
          merchantId: account.id,
          merchantName: account.name,
          integrationMerchantAccountGroupName: account.integrationMerchantAccountGroupName,
          isActive: account.active,
          createdAt: account.createdAt,
        })),
      ),
    );
    tempRes[0].rowspan = { count: tempRes?.length, name: 'providerName' };

    return [...result, ...tempRes];
  }, []);
});
